import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthProvider';

export default function Footer() {
  const navigate = useNavigate();
  const { user } = useAuth();

  return (
    <>
      <style>{`
        .shared-footer {
          padding: 5rem 2.5rem 2rem;
          max-width: 1400px;
          margin: 0 auto;
          border-top: 1px solid var(--border-subtle);
        }

        .shared-footer-content {
          display: grid;
          grid-template-columns: 2fr 1fr 1fr 1fr;
          gap: 3rem;
          margin-bottom: 3rem;
        }

        .shared-footer-brand h3 {
          font-family: 'Roboto Slab', serif;
          font-weight: 900;
          font-size: 1.5rem;
          margin-bottom: 1rem;
          background: linear-gradient(135deg, var(--accent-primary) 0%, #F39C6B 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .shared-footer-brand p {
          color: var(--text-secondary);
          line-height: 1.7;
        }

        .shared-footer-section h4 {
          font-family: 'Montserrat', sans-serif;
          font-weight: 700;
          margin-bottom: 1rem;
        }

        .shared-footer-links {
          display: flex;
          flex-direction: column;
          gap: 0.75rem;
        }

        .shared-footer-link {
          color: var(--text-secondary);
          cursor: pointer;
          transition: color 0.2s;
        }

        .shared-footer-link:hover {
          color: var(--accent-primary);
        }

        .shared-footer-bottom {
          padding-top: 2rem;
          border-top: 1px solid var(--border-subtle);
          display: flex;
          justify-content: space-between;
          align-items: center;
          color: var(--text-muted);
          font-size: 0.875rem;
        }

        @media (max-width: 768px) {
          .shared-footer {
            padding: 4rem 1.5rem 2rem;
          }

          .shared-footer-content {
            grid-template-columns: 1fr;
            gap: 2rem;
          }

          .shared-footer-bottom {
            flex-direction: column;
            gap: 1rem;
            text-align: center;
          }
        }
      `}</style>

      <footer className="shared-footer">
        <div className="shared-footer-content">
          <div className="shared-footer-brand">
            <h3>MIZAR</h3>
            <p>Flight pricing intelligence for the travel industry. Decision infrastructure that drives bookings.</p>
          </div>

          <div className="shared-footer-section">
            <h4>Product</h4>
            <div className="shared-footer-links">
              <span className="shared-footer-link" onClick={() => navigate('/implementation')}>Documentation</span>
              {user && <span className="shared-footer-link" onClick={() => navigate('/console')}>Console</span>}
            </div>
          </div>

          <div className="shared-footer-section">
            <h4>Company</h4>
            <div className="shared-footer-links">
              <span className="shared-footer-link" onClick={() => navigate('/about')}>About</span>
              <span className="shared-footer-link" onClick={() => navigate('/contact')}>Contact</span>
            </div>
          </div>

          <div className="shared-footer-section">
            <h4>Legal</h4>
            <div className="shared-footer-links">
              <span className="shared-footer-link" onClick={() => navigate('/privacy')}>Privacy</span>
              <span className="shared-footer-link" onClick={() => navigate('/terms')}>Terms</span>
            </div>
          </div>
        </div>

        <div className="shared-footer-bottom">
          <span>© 2026 MIZAR. All rights reserved.</span>
          <span>info@traveltxter.com</span>
        </div>
      </footer>
    </>
  );
}
